<script>
import EgLottiePlayer from "@/components/global/eg_lottie_player.vue";

export default {
  name: "LoadingStep",

  components: {
    "eg-lottie-player": EgLottiePlayer,
  },
  data() {
    return {
      progress: 0,
      timer: null,
      messageIndex: 0,
    };
  },
  computed: {
    messages() {
      return [
        this.$t("freeTools.grade.analyzingSubmission"),
        this.$t("freeTools.grade.applyingRubric"),
        this.$t("freeTools.grade.generatingFeedback"),
        this.$t("freeTools.grade.generatingGrammarReport"),
        this.$t("freeTools.grade.calculatingGrade"),
        this.$t("freeTools.grade.preparingResults"),
      ];
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      this.progress++;
      if (this.progress % 14 === 0) {
        if (this.messageIndex < this.messages.length - 1) {
          this.messageIndex++;
        }
      }
    }, 300);
  },
  beforeMount() {
    clearInterval(this.timer);
  },
};
</script>

<template>
  <div class="d-flex flex-column align-items-center my-5 flex-gap-1">
    <eg-b-progress class="progressbar" :value="progress" :max="80" />
    <div>{{ messages[messageIndex] }}</div>
    <eg-lottie-player
      src="/lottie/grading.lottie"
      loop
      autoplay
      style="width: 100%; height: 400px"
    />
  </div>
</template>

<style scoped lang="scss">
.progressbar {
  width: 75%;
  border-radius: 16px;
  ::v-deep {
    div[role="progressbar"] {
      background-color: #6a50f3;
    }
  }
}
</style>
